import React, { useState, useEffect } from "react";
import SideBarTest from "./SideBarTest";
import Avatar from "@mui/material/Avatar";

import CloseIcon from "@mui/icons-material/Close";
import {
  canOfficeAddMember,
  getSlotCapacityRules,
} from "../../../../common/utils/capacity";

const CardClientTest = ({
  appointment,
  checkCard,
  isSideBarOpen,
  handleToggleSidebar,
  clientScheduler,
  isPastDayAndHour,
  setClientActive,
  activeClientInformation,
  activeClientId,
  activeReschedule,
  setActiveClientInformation,
  onOpenSlotDetails,
  weekCompact,
  highlightedClientId,
  // Bulk-scheduling experiment (this branch only): while active, every cell
  // renders as a plain "count + selectable" tile instead of the normal
  // avatar/name display, so the trainer can scan capacity at a glance and
  // tap up to 3 slots for the member already chosen in the New Appointment
  // popup. See SchedulerTest.jsx for the mode/selection state itself.
  bulkMode,
  bulkSelected,
  bulkWasOriginal,
  bulkDisabled,
  onBulkToggle,
  bulkMemberInitials,
  bulkMemberGender,
}) => {
  const [existClient, setExistClient] = useState(false);
  const [existClientNoReschedule, setExistClientNoReschedule] = useState(false);

  const [selectedClient, setSelectedClient] = useState(null);
  const images = [
    "/exercise.png",
    "/weightlifting.png",
    "/tool.png",
    "/stretching-exercises.png",
    "/weightlifter.png",
  ];

  const getRandomImage = () => {
    return images[Math.floor(Math.random() * images.length)];
  };

  useEffect(() => {
    setExistClientNoReschedule(false);
    if (appointment && activeReschedule) {
      const client = appointment.bookings_client.find(
        (booking_client) => activeClientId === booking_client.client_id
      );

      if (client) {
        setExistClient(true);
        setSelectedClient(client);
      } else {
        setExistClient(false);
        setSelectedClient(null);
      }
    }
    if (appointment && activeClientInformation != null) {
      let client = [];
      if (activeClientInformation.client_id != null) {
        client = appointment.bookings_client.find(
          (booking_client) =>
            activeClientInformation.client_id === booking_client.client_id
        );
      } else {
        client = appointment.bookings_client.find(
          (booking_client) =>
            activeClientInformation.id === booking_client.client_id
        );
      }

      if (client) {
        console.log(client, "ovo je klijent");
        setExistClientNoReschedule(true);
      }
    }
  }, [appointment, activeClientId, activeReschedule]);

  const renderActiveRescheduleCards = () => {
    if (!activeReschedule || !appointment) {
      return;
    } else if (!existClient) {
      return (
        <div
          className="space-time-slot"
          onClick={
            () =>
              // Gated by the absolute capacity (7), not free_bookings (which reaches 0 at the
              // normal 6-person cap on a morning slot) — rescheduling an existing appointment
              // into this slot is an Office App action, so it must still allow the same
              // morning-slot override New Appointment/Add Member does, only blocking once the
              // hard ceiling is actually reached.
              isPastDayAndHour || !canOfficeAddMember(appointment.used_bookings)
                ? null
                : checkCard(appointment.start, appointment.id, appointment)

            // checkCard(appointment.start, appointment.id, appointment)
          }
          style={{
            color: "#404040",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "700",
            borderRadius: "7px",
            width: "100%",
            backgroundColor:
              isPastDayAndHour || !canOfficeAddMember(appointment.used_bookings)
                ? "rgb(242, 242, 242)"
                : !appointment.checked
                ? "rgb(249, 249, 249)"
                : "rgba(208, 238, 198, 1)",
            // backgroundColor: !appointment.checked
            //   ? "white"
            //   : "rgba(208, 238, 198, 1)",
          }}
        >
          {appointment.used_bookings}/{appointment.max_bookings}
        </div>
      );
    } else {
      return (
        <div
          onClick={
            () =>
              appointment.bookings_client?.[0]?.status === "noshow"
                ? null
                : !isPastDayAndHour
                ? checkCard(appointment.start, appointment.id, appointment)
                : null
            // checkCard(appointment.start, appointment.id, appointment)
          }
          className="exist-client-card"
          style={{
            alignItems: "center",
            fontSize: "10px",
            borderRadius: "7px",
            width: "100%",

            color: "black",
            backgroundColor:
              appointment.bookings_client?.[0]?.status === "noshow"
                ? "red"
                : isPastDayAndHour
                ? "rgb(242, 242, 242)"
                : appointment.checked
                ? "rgba(255, 0, 0, 0.2)"
                : "rgba(208, 238, 198, 1)",
            width: "100%",
            height: "100%",
          }}
        >
          <div className="help-div-exist">
            <div
              className="circle-card-browser"
              style={{
                width: "10px",
                height: "10px",
                display:
                  appointment.bookings_client?.[0]?.status === "noshow"
                    ? "none"
                    : "",
                backgroundColor: "red",
                border: "1px solid black",
                borderRadius: "50%",
                marginRight: "5px",
              }}
            ></div>
            <img
              className="img-lifter"
              style={{ width: "20px", height: "20px" }}
              src={"/weightlifter.png"}
              alt="Activity"
            />

            <span
              className="active-reshedule-name"
              style={{
                alignItems: "center",
                textTransform: "uppercase",
                fontWeight: "700",

                textDecoration: appointment.checked ? "line-through" : "none",
                color: appointment.checked ? "gray" : "black",
              }}
            >
              {appointment.bookings_client?.[0]?.status === "noshow"
                ? "NIJE SE POJAVIO/LA"
                : `${selectedClient.first_name} ${selectedClient.last_name}`}
            </span>
          </div>

          <span
            className="active-reshedule"
            style={{
              marginLeft: "auto",

              alignItems: "center",
            }}
          >
            {appointment.checked ? (
              <CloseIcon
                style={{ color: "rgba(255, 0, 0, 1)" }}
                sx={{ fontSize: 15 }}
              />
            ) : (
              <img
                style={{ width: "20px", height: "20px" }}
                src={"/weightlifter.png"}
                alt="Activity"
              />
            )}
          </span>
        </div>
      );
    }
  };

  // Bulk-scheduling experiment (this branch only) — placed after every hook
  // above so it never skips one across a bulkMode toggle (an early return
  // before the hooks would violate the Rules of Hooks: this component would
  // call a different number of hooks depending on bulkMode on consecutive
  // renders). Renders a plain "count + selectable" tile instead of the
  // normal avatar/name layout.
  if (bulkMode) {
    // Pure preview derived straight from selection state on every render — never a
    // separately-tracked/incremented counter, so it can't drift across rerenders. A slot the
    // member already had (bulkWasOriginal) is already counted in `used_bookings`, so it only
    // moves the preview when the CURRENT selection state differs from that starting point:
    // still selected → no change, deselected → preview -1, newly selected → preview +1.
    const used = appointment?.used_bookings || 0;
    const displayCount =
      used + (bulkSelected ? 1 : 0) - (bulkWasOriginal ? 1 : 0);
    // Past slots are read-only in this flow regardless of selection state (an existing
    // appointment there can't be un-booked here, and a new one can't be booked into the past
    // either) — locked unconditionally. A slot that's merely full only blocks NEW selections;
    // toggling off a slot the member is already occupying must still work.
    const isLocked = isPastDayAndHour;
    return (
      <div
        className={`hf-bulk-cell${bulkSelected ? " hf-bulk-selected" : ""}${
          isLocked || (bulkDisabled && !bulkSelected) ? " hf-bulk-disabled" : ""
        }`}
        onClick={() => {
          if (!appointment || isLocked) return;
          if (!bulkSelected && bulkDisabled) return;
          onBulkToggle && onBulkToggle(appointment);
        }}
      >
        <span className="hf-bulk-cell-count">
          {displayCount > 0 && (
            <span className="hf-appt-count">{displayCount}</span>
          )}
        </span>
        {bulkSelected && (
          <span
            className="hf-bulk-cell-avatar"
            style={{
              backgroundColor:
                bulkMemberGender === "Male" ? "#97dfff" : "#FF8E8B",
            }}
          >
            {bulkMemberInitials}
          </span>
        )}
      </div>
    );
  }

  return (
    <div
      onClick={() => {
        if (activeReschedule || !onOpenSlotDetails) return;
        // Booked Members opens for a past slot too, but view-only, when it already has
        // bookings to look back on (Edit/Remove/Add disable themselves inside that popup) — an
        // empty *and* past slot has nothing left to show, so that combination alone stays inert.
        const hasBookings = appointment && appointment.bookings_client.length > 0;
        if (hasBookings || !isPastDayAndHour) {
          onOpenSlotDetails();
        }
      }}
      style={{ display: "flex" }}
      className={`cell-helper ${
        appointment &&
        appointment.bookings_client.length > 0 &&
        appointment.bookings_client?.[0]?.status != "noshow" &&
        existClientNoReschedule &&
        !activeReschedule
          ? "cell-helper-client"
          : ""
      }`}
    >
      {activeReschedule ? (
        <div className="stacked-avataras-reschedule">
          {renderActiveRescheduleCards()}
        </div>
      ) : (
        appointment &&
        (() => {
          // Same "no-show is still a booking, just not a visible one" rule as PopUpCard.jsx's
          // Booked Members popup — a no-show shouldn't keep showing up on the calendar grid
          // itself either.
          const bookedClients = appointment.bookings_client.filter(
            (bc) => bc.status !== "canceled" && bc.status !== "noshow"
          );
          const count = bookedClients.length;

          // Locally recomputed instead of trusting `appointment.used_bookings` — that field
          // comes from whatever snapshot this appointment was last fetched with, and a
          // cancellation elsewhere doesn't always refresh it, so it can go stale and disagree
          // with `bookedClients` above (the reported bug: 2 of 3 bookings canceled, avatars
          // correctly dropped to 1, but the adjacent count kept showing the old 3). A no-show
          // still occupies the slot's capacity even though it's excluded from `bookedClients`
          // (no avatar shown for it) — `!== "canceled"` alone (not the stricter filter above)
          // keeps that counted here, same as this file's existing "no-show still uses capacity"
          // rule for the count-only (no avatars) case below.
          const used = appointment.bookings_client.filter(
            (bc) => bc.status !== "canceled"
          ).length;
          // "Full" means the slot's normal (User App) capacity is reached — 6 for a morning
          // slot, 7 for afternoon/evening — derived from the slot's hour, not `appointment.
          // max_bookings` (which is always the absolute ceiling, 7). Only drives the isFull
          // color cue on the big reservation-count number now — the number itself is always
          // just `used`, the slot's actual max isn't shown anywhere on the calendar grid.
          const isFull =
            used >=
            getSlotCapacityRules(new Date(appointment.start).getHours())
              .normalCapacity;

          if (count === 0) {
            // A no-show still consumes the slot's capacity even though nobody's left to
            // display — show the bare reservation count instead of an empty-looking (and
            // misleadingly still-bookable) cell. A fully-canceled slot has used === 0 too
            // (canceled frees the slot), so that case still returns null exactly as before.
            if (used === 0) return null;
            return (
              <div className="hf-appt-wrap">
                <span
                  className={`hf-appt-count${isFull ? " hf-appt-count-full" : ""}`}
                >
                  {used}
                </span>
              </div>
            );
          }

          const colorClasses = ["hf-appt-c0", "hf-appt-c1", "hf-appt-c2"];

          const initialsOf = (bc) =>
            `${bc.first_name ? bc.first_name[0].toUpperCase() : "?"}${
              bc.last_name ? bc.last_name[0].toUpperCase() : "?"
            }`;

          // Selected-member highlight mode (Calendar → Booked Members → click a member row):
          // `highlightedClientId` is set for every cell while active, so a slot with none of
          // that member's bookings needs to know to visually recede (`hf-appt-dimmed`) rather
          // than just doing nothing — only a slot that actually contains them gets the blue
          // ring/tint (`hf-appt-highlighted`).
          const highlightModeActive = highlightedClientId != null;
          const highlightedBooking = highlightModeActive
            ? bookedClients.find((bc) => bc.client_id === highlightedClientId)
            : null;
          const containsHighlighted = !!highlightedBooking;
          const wrapHighlightClass = containsHighlighted
            ? " hf-appt-highlighted"
            : highlightModeActive
            ? " hf-appt-dimmed"
            : "";

          // A highlighted slot shows the selected member's name filling the whole cell, plus the
          // slot's capacity count — no other members' avatars/initials — regardless of how many
          // people are actually booked in or whether this is a compact Mobile Week View cell.
          // Non-highlighted slots (including dimmed ones, while some other member is selected)
          // fall through to the normal rendering below, completely untouched.
          if (containsHighlighted) {
            // The Mobile Week View's compact cells (~54px wide) never fit a full name even with
            // ellipsis truncation — "Ime P." is the deliberate short form for that context.
            const displayName = weekCompact
              ? `${highlightedBooking.first_name || ""}${
                  highlightedBooking.last_name
                    ? ` ${highlightedBooking.last_name
                        .charAt(0)
                        .toUpperCase()}.`
                    : ""
                }`.trim()
              : `${highlightedBooking.first_name || ""} ${
                  highlightedBooking.last_name || ""
                }`.trim();
            return (
              <div className="hf-appt-wrap hf-appt-highlighted hf-appt-fullname-wrap">
                <span className="hf-appt-fullname-text">{displayName}</span>
                <span
                  className={`hf-appt-fullname-count${
                    isFull ? " hf-appt-count-full" : ""
                  }`}
                >
                  {used}
                </span>
              </div>
            );
          }

          // Desktop/Tablet always renders this same overlapping-avatar-circles summary now,
          // regardless of count (1 booked looks the same as 5, just with fewer circles and no
          // "+N") — full name+colored-card chips used to only collapse into this at 4+, but that
          // made a 1-3-booked cell look like a completely different, unrelated component next to
          // a 4+ one. Full names/photos/actions still live one click away in the Booked Members
          // popup; the calendar itself only needs to convey "who / how busy / is it full" at a
          // glance, consistently, and this also means real member photos (once added) render
          // identically everywhere instead of only in the 4+ case.
          // Mobile Week View (`weekCompact`) is untouched — it already renders every count
          // through the `.hf-appt-cluster` branch below, with its own CSS hiding names and
          // shrinking avatars down to circles, matching the reference layout there too.
          if (!weekCompact) {
            const visible = bookedClients.slice(0, 3);
            const overflow = count - visible.length;
            return (
              <div className={`hf-appt-wrap${wrapHighlightClass}`}>
                <div className="hf-appt-summary">
                  <div className="hf-appt-summary-avatars">
                    {visible.map((bc, index) => (
                      <Avatar
                        key={bc.booking_id || `${bc.client_id}-${index}`}
                        // Same 3-color cycle as the 1-3-booked chip cards' left border
                        // (hf-appt-c0/c1/c2 below) — a colored ring here instead of a colored
                        // background, so both views read as the same "per-member color" system
                        // rather than two unrelated looks.
                        className={`hf-appt-summary-avatar hf-appt-summary-avatar-c${
                          index % 3
                        }`}
                        src={bc.photo_url || undefined}
                        sx={{
                          backgroundColor:
                            bc.gender === "Male" ? "#97dfff" : "#FF8E8B",
                          // Same light-red treatment as the 1-3-member view's names — a
                          // subtly recognizable "this already happened" cue, not a loud
                          // red-alert background.
                          color: isPastDayAndHour ? "#f87171" : "black",
                          fontWeight: 600,
                        }}
                      >
                        {initialsOf(bc)}
                      </Avatar>
                    ))}
                    {overflow > 0 && (
                      <span className="hf-appt-summary-overflow">
                        +{overflow}
                      </span>
                    )}
                  </div>
                  <span
                    className={`hf-appt-summary-count${
                      isFull ? " hf-appt-summary-full" : ""
                    }`}
                  >
                    {used}
                  </span>
                </div>
              </div>
            );
          }

          const sizeClass =
            count === 1
              ? "hf-appt-cluster-full"
              : count === 2
              ? "hf-appt-cluster-half"
              : "hf-appt-cluster-third";

          return (
            <div className={`hf-appt-wrap${wrapHighlightClass}`}>
              <div className={`hf-appt-cluster ${sizeClass}`}>
                {bookedClients.map((booking_client, index) => (
                  <div
                    key={
                      booking_client.booking_id ||
                      `${booking_client.client_id}-${index}`
                    }
                    className={`hf-appt-card ${colorClasses[index % 3]}`}
                  >
                    <Avatar
                      className="hf-appt-avatar"
                      src={booking_client.photo_url || undefined}
                      sx={{
                        backgroundColor:
                          booking_client.gender === "Male"
                            ? "#97dfff"
                            : "#FF8E8B",
                        // Light red for a past appointment — same font size/weight/background,
                        // just a subtle "this already happened" text cue, not a loud alert.
                        color: isPastDayAndHour ? "#f87171" : "black",
                        fontWeight: "600",
                      }}
                    >
                      {initialsOf(booking_client)}
                    </Avatar>
                    <span
                      className={`hf-appt-name${
                        isPastDayAndHour ? " hf-appt-name-past" : ""
                      }`}
                    >
                      {booking_client.first_name} {booking_client.last_name}
                    </span>
                  </div>
                ))}
              </div>
              <span
                className={`hf-appt-count${isFull ? " hf-appt-count-full" : ""}`}
              >
                {used}
              </span>
            </div>
          );
        })()
      )}
    </div>
  );
};

export default CardClientTest;
